type CustomBorderIconProps = React.SVGProps<SVGSVGElement> & {
    style?: React.CSSProperties
}

const BorderOutsideIcon = ({ style = {}, ...otherProps }: CustomBorderIconProps) => (
    <svg
        width='20'
        height='20'
        viewBox='0 0 257 257'
        fill='currentColor'
        style={{
            display: 'inline-block',
            flexShrink: 0,
            ...style
        }}
        {...otherProps}>
        <rect className='st0' x='74.97' y='117.79' width='21.42' height='21.42' />
        <rect className='st0' x='117.8' y='160.61' width='21.42' height='21.42' />
        <rect className='st0' x='160.63' y='117.79' width='21.42' height='21.42' />
        <path className='st0' d='M214.17,32.12H42.85s-.01,0-.02,0-.01,0-.02,0c-5.89,0-10.71,4.82-10.71,10.71v171.33c0,5.89,4.82,10.71,10.71,10.71h171.33s.01,0,.02,0,.01,0,.02,0c5.89,0,10.71-4.82,10.71-10.71V42.83c0-5.89-4.82-10.71-10.71-10.71ZM53.52,53.54h149.95v149.91H53.52V53.54Z' />
        <rect className='st0' x='117.8' y='117.79' width='21.42' height='21.42' />
        <rect className='st0' x='117.8' y='74.96' width='21.42' height='21.42' />
    </svg>
)

export default BorderOutsideIcon
